<!--
  Só renderiza quando há aviso da empresa selecionada. Sem avisos, a faixa não
  ocupa espaço nenhum nas telas. Fechada mostra uma linha; aberta, cada aviso.
-->
<div *ngIf="avisos.length && !naTelaDeLogins" class="aviso-rpa" role="alert">
  <div class="aviso-rpa__cabecalho">
    <strong class="aviso-rpa__titulo">
      {{ avisos.length === 1 ? 'Uma automação parou' : avisos.length + ' automações pararam' }}
    </strong>
    <span *ngIf="!detalhesAbertos" class="aviso-rpa__resumo">{{ resumo }}</span>
    <button
      type="button"
      class="aviso-rpa__alternar"
      [attr.aria-expanded]="detalhesAbertos"
      (click)="detalhesAbertos = !detalhesAbertos"
    >
      {{ detalhesAbertos ? 'Ocultar detalhes' : 'Ver detalhes' }}
    </button>
  </div>

  <ul *ngIf="detalhesAbertos" class="aviso-rpa__lista">
    <li *ngFor="let item of avisos">
      <span class="aviso-rpa__operadora">{{ item.rotulo }}</span>
      <span class="aviso-rpa__texto">{{ item.aviso }}</span>

      <!-- Só oferece o caminho quando trocar a senha de fato resolve -->
      <button
        *ngIf="item.trocarSenhaResolve && podeAbrirATela"
        type="button"
        class="aviso-rpa__acao"
        (click)="abrirTelaDeLogins()"
      >
        Atualizar login
      </button>
    </li>
  </ul>
</div>
